export default {
	'blog': '블로그 설정',
	'blog-desc': '더 상세한 블로그 설정입니다.',
	'profile': '계정 설정',
	'profile-desc': '깃허브를 포함한 계정 설정입니다.',
};
